var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkAll"},[(_vm.selectIds)?_c('el-tree',{attrs:{"data":_vm.data,"show-checkbox":"","node-key":"id","default-checked-keys":_vm.selectIds,"props":_vm.defaultProps},on:{"check":_vm.currentChecked}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }